import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { Sparkles, Volume2 } from "lucide-react";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const VoiceConsentDialog = ({
  open = false,
  onAcceptNeural,
  onUseSystem,
  onClose,
}) => {
  const t = useScrollytellTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="piper-consent-title"
      aria-describedby="piper-consent-desc"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="piper-consent-title" sx={{ fontWeight: 700, pb: 1 }}>
        {t("voiceConsentDialog.title", "Velg fortellerstemme for historien")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="piper-consent-desc"
          sx={{ color: "text.primary", fontSize: "14px", lineHeight: 1.6 }}
        >
          {t(
            "voiceConsentDialog.description",
            "For best mulig opplevelse kan Virtuelt Museum laste ned Nasjonalbibliotekets naturlige norske AI-stemme (~60 MB). Stemmen lagres lokalt i nettleseren din slik at den kun lastes ned én gang og fungerer uten nett senere. Du kan også velge å bruke datamaskinens enkle systemstemme (0 MB)."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          pt: 1,
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
          gap: 1,
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          onClick={onUseSystem}
          startIcon={<Volume2 size={18} />}
          sx={{ textTransform: "none", minHeight: "44px", minWidth: "44px" }}
        >
          {t("voiceConsentDialog.useSystem", "Bruk enkel systemstemme (0 MB)")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAcceptNeural}
          autoFocus
          startIcon={<Sparkles size={18} />}
          sx={{ textTransform: "none", fontWeight: 600, minHeight: "44px", minWidth: "44px" }}
        >
          {t(
            "voiceConsentDialog.acceptNeural",
            "Last ned naturlig norsk stemme (ca. 60 MB)"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
